"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classnames = _interopRequireDefault(require("classnames"));

var _Person = _interopRequireDefault(require("@insided/destination/icons/Person"));

var LoginAnchor = function LoginAnchor(_ref) {
  var title = _ref.title,
      ssoLoginUrl = _ref.ssoLoginUrl,
      showAuthPage = _ref.showAuthPage,
      embeddedLoginUrl = _ref.embeddedLoginUrl;
  var loginUrl = ssoLoginUrl || embeddedLoginUrl || (showAuthPage ? '/member/login' : '#');
  return (0, _preact.h)("a", {
    role: "button",
    href: (0, _absoluteUrlRuntime.resolveUrl)(loginUrl),
    className: (0, _classnames.default)('header-login-button', 'qa-header-login-button', 'btn', 'btn--secondary'),
    onClick: function onClick(e) {
      if (ssoLoginUrl || embeddedLoginUrl || showAuthPage) return;
      e.preventDefault();
      window.app.events.commands.execute('modal:login:show');
    }
  }, (0, _preact.h)("span", {
    "aria-hidden": "true",
    className: "header-navigation-button-icon"
  }, (0, _preact.h)(_Person.default, {
    fill: "currentColor"
  })), (0, _preact.h)("span", null, title));
};

var _default = LoginAnchor;
exports.default = _default;